"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = __importDefault(require("./utils"));
class Subscription {
    constructor(wse, eventFilters, callback) {
        this.enabled = true;
        this.wse = wse;
        this.eventFilters = eventFilters;
        this.eventListener = (mEvent) => {
            const event = mEvent;
            const [meta, body] = utils_1.default.splitWsgData(event.data);
            if (this.enabled
                && meta.type === 'ServerNotification'
                && body.subscriptionId === this.subscriptionInfo.id) {
                callback(body);
            }
        };
        this.setupWsEventListener();
    }
    setupWsEventListener() {
        this.wse.ws.addEventListener('message', this.eventListener);
    }
    get requestBody() {
        return {
            deliveryMode: { transportType: 'WebSocket' },
            eventFilters: this.eventFilters,
        };
    }
    async subscribe() {
        this.subscriptionInfo = (await this.wse.request('POST', '/restapi/v1.0/subscription', this.requestBody)).data;
    }
    async refresh() {
        if (!this.subscriptionInfo) {
            return;
        }
        try {
            this.subscriptionInfo = (await this.wse.request('PUT', `/restapi/v1.0/subscription/${this.subscriptionInfo.id}`, this.requestBody)).data;
        }
        catch (e) {
            const re = e;
            if (re.response && re.response.status === 404) {
                // subscription expired
                await this.subscribe();
            }
        }
    }
    async revoke() {
        if (!this.subscriptionInfo) {
            return;
        }
        try {
            await this.wse.request('DELETE', `/restapi/v1.0/subscription/${this.subscriptionInfo.id}`);
        }
        catch (e) {
            const re = e;
            if (re.response && re.response.status === 404) {
                // ignore
                if (this.wse.options.debugMode) {
                    console.debug(`Subscription ${this.subscriptionInfo.id} doesn't exist on server side`);
                }
            }
            else if (re.response && re.response.status === 401) {
                // ignore
                if (this.wse.options.debugMode) {
                    console.debug('Token invalid when trying to revoke subscription');
                }
            }
            else {
                throw e;
            }
        }
        this.remove();
    }
    remove() {
        if (this.timeout) {
            global.clearTimeout(this.timeout);
            this.timeout = undefined;
        }
        this.enabled = false;
        this.subscriptionInfo = undefined;
        if (this.wse.ws) {
            this.wse.ws.removeEventListener('message', this.eventListener);
        }
        this.wse.subscription = undefined;
    }
}
exports.default = Subscription;
//# sourceMappingURL=subscription.js.map